export default __webpack_public_path__ + "static/media/mswipe.ce416e05.svg";